import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/lucide-react@1.63.0_@types+react@19.3.0_react@19.3.1/node_modules/lucide-react/dist/esm/Icon.mjs");
;
import(/* webpackMode: "eager" */ "/app/node_modules/.pnpm/next@16.4.3_@babel+core@7.29.7_@opentelemetry+api@1.9.1_@types+node@24.19.2_react-dom@19.3.1_react@19.3.1__react@19.3.1/node_modules/next/dist/client/app-dir/link.js");
;
import(/* webpackMode: "eager", webpackExports: ["DashboardPreview"] */ "/app/src/ui/components/affiliate/dashboard-preview.tsx");
